import { User } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames,
    AssignUsersApplicationsAction,
    AssignUsersGroupsAction,
    AssignUsersWorkspaceAction,
    ClearSingleUserAction,
    CopySingleUserAction,
    CreateSingleUserAction,
    CreateUsersApplicationKeyAction,
    FetchAllUsersAction,
    FetchSingleUserAction,
    FetchTableUsersAction,
    FetchTableUsersNoSearchAction,
    ImportCSVAction,
    NewSingleUserAction,
    SavedSingleUserAction,
    SaveSingleUserAction,
    StoreAllUsersAction,
    StoreSingleUserAction,
    StoreTableUsersAction,
    UsersAction,
    StoreUsersApplicationKeyAction,
    ResetUserApplicationKeyAction
} from './actions';

export function FetchTableUsersNoSearch(): FetchTableUsersNoSearchAction
{
    return {
        type: ActionTypeNames.FetchTableUsersNoSearch
    };
}

export function fetchTableUsers(): FetchTableUsersAction {
    return {
        type: ActionTypeNames.FetchTableUsers
    };
}

export function fetchAllUsers(): FetchAllUsersAction {
    return {
        type: ActionTypeNames.FetchAllUsers
    };
}

function usersActionCreator<T extends ActionTypeNames>(type: T) {
    return (ids: string[]): UsersAction<T> => {
        return {
            type,
            userIds: ids,
        };
    };
}

export function storeTableUsers(users: User[]): StoreTableUsersAction {
    return {
        type: ActionTypeNames.StoreTableUsers,
        users,
    };
}

export function storeAllUsers(users: User[]): StoreAllUsersAction {
    return {
        type: ActionTypeNames.StoreAllUsers,
        users,
    };
}

export function fetchSingleUser(id: string): FetchSingleUserAction {
    return {
        id,
        type: ActionTypeNames.FetchSingleUser
    };
}
export function newSingleUser(): NewSingleUserAction {
    return {
        type: ActionTypeNames.NewSingleUser
    };
}

export function copySingleUser(id: string): CopySingleUserAction {
    return {
        id,
        type: ActionTypeNames.CopySingleUser
    };
}

export function storeSingleUser(user: Partial<User>): StoreSingleUserAction {
    return {
        type: ActionTypeNames.StoreSingleUser,
        user,
    };
}

export function saveSingleUser(
    user: Partial<User>,
    workspaceId?: string,
    apps?: Array<{ id: string, value: boolean }>,
    groups?: Array<{ id: string, value: boolean }>,
    privileges?: Array<{ name: string, value: boolean }>
): SaveSingleUserAction {
    return {
        apps,
        groups,
        privileges,
        type: ActionTypeNames.SaveSingleUser,
        user,
        workspaceId,
    };
}

export function createSingleUser(
    mail: boolean | undefined,
    user: Partial<User>,
    workspaceId?: string,
    apps?: Array<{ id: string, value: boolean }>,
    groups?: Array<{ id: string, value: boolean }>,
    privileges?: Array<{ name: string, value: boolean }>
): CreateSingleUserAction {
    return {
        apps,
        groups,
        mail,
        privileges,
        type: ActionTypeNames.CreateSingleUser,
        user,
        workspaceId,
    };
}

export function clearSingleUser(): ClearSingleUserAction {
    return {
        type: ActionTypeNames.ClearSingleUser,
    };
}

export function savedSingleUser(): SavedSingleUserAction {
    return {
        type: ActionTypeNames.SavedSingleUser,
    };
}

export const activateUsers = usersActionCreator(ActionTypeNames.ActivateUsers);
export const updateUsers = usersActionCreator(ActionTypeNames.UpdateUsers);
export const deactivateUsers = usersActionCreator(ActionTypeNames.DeactivateUsers);
export const deleteUsers = usersActionCreator(ActionTypeNames.DeleteUsers);
export const sendNewUserMail = usersActionCreator(ActionTypeNames.SendNewUserMail);
export const sendResetPasswordMail = usersActionCreator(ActionTypeNames.SendResetPasswordMail);
export const sendMigratePasswordMail = usersActionCreator(ActionTypeNames.SendMigratePasswordMail);
export const sendMigrateAccountMail = usersActionCreator(ActionTypeNames.SendMigrateAccountMail);
export const sendVerifyEmailMail = usersActionCreator(ActionTypeNames.SendVerifyEmailMail);
export const synchronizeUsers = usersActionCreator(ActionTypeNames.SynchronizeUsers);

export function assignUsersWorkspace(userIds: string[], workspaceId: string): AssignUsersWorkspaceAction {
    return {
        type: ActionTypeNames.AssignUsersWorkspace,
        userIds,
        workspaceId,
    };
}

export function assignUsersApplications(userIds: string[], appIds: string[]): AssignUsersApplicationsAction {
    return {
        appIds,
        type: ActionTypeNames.AssignUsersApplications,
        userIds,
    };
}

export function createUserApplicationKey(userIds: string[], appId: string): CreateUsersApplicationKeyAction {
    return {
        appId,
        type: ActionTypeNames.CreateUserApplicationKey,
        userIds
    }
}

export function storeUserApplicationKey(userIds: string[], appId: string, applicationKey: string): StoreUsersApplicationKeyAction {
    return {
        type: ActionTypeNames.StoreUserApplicationKey,
        appId,
        userIds,
        applicationKey
    }
}

export function resetUserApplicationKey(): ResetUserApplicationKeyAction {
    return {
        type: ActionTypeNames.ResetUserApplicationKey,
        appId: '',
        userIds: [],
        applicationKey: ''
    }
}

export function assignUsersGroups(userIds: string[], groupIds: string[]): AssignUsersGroupsAction {
    return {
        groupIds,
        type: ActionTypeNames.AssignUsersGroups,
        userIds,
    };
}

export function importCSV(csv: string, emailUsers: boolean, workspaceId: string): ImportCSVAction {
    return {
        csv,
        emailUsers,
        type: ActionTypeNames.ImportCSV,
        workspaceId,
    };
}

/* export function deleteUser(name: string): DeleteUserAction {
    return {
        type: ActionTypeNames.DeleteUser,
        name
    };
}*/
